import { useCopy } from '../content'
import { ContactSection } from '../components/contact/ContactSection'
import { Faq } from '../components/home/Faq'
import { Hero } from '../components/home/Hero'
import { Manifesto } from '../components/home/Manifesto'
import { Numeri } from '../components/home/Numeri'
import { Servizi } from '../components/home/Servizi'
import { ZoneBand } from '../components/home/ZoneBand'

/**
 * The home page. `<main id="main">` is the skip link's target; the page's
 * one `<h1 tabIndex={-1}>` (the router's focus target after a client
 * navigation) lives in `Hero`. Every section brings its own container, so
 * `<main>` carries none.
 */
export default function HomePage() {
  const copy = useCopy()
  return (
    <main id="main">
      <Hero />
      <Manifesto />
      <Servizi />
      <Numeri />
      <ZoneBand />
      <Faq items={copy.faq.items} title={copy.faq.title} eyebrow={copy.faq.eyebrow} />
      <ContactSection />
    </main>
  )
}
